import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import HowItWorks from "@/components/site/HowItWorks";
import WhyOpenDeposit from "@/components/site/WhyOpenDeposit";
import Pricing from "@/components/site/Pricing";
import CTASection from "@/components/site/CTASection";
import Footer from "@/components/site/Footer";
import ContactDialog from "@/components/site/ContactDialog";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative bg-white text-[#0a0a0a] overflow-clip">
      <Navbar />
      <main>
        <Hero />
        <HowItWorks />
        <WhyOpenDeposit />
        <Pricing />
        <CTASection />
      </main>
      <Footer />
      <ContactDialog />
    </div>
  );
}
